<div class="form tpl-form-2">
  <form action="">
    <div class="form-row">
      <div class="col-12">
        <div class="form-title-1">
          Responsabilidade socioambiental
          <span
            title="Conforme a Resolução nº 4.327 de 25/04/2014, a qual trata da política de responsabilidade socioambiental (PRSA), o cliente declara que:"
            class="click-info" data-info-id="info-1"><i class="info">i</i></span>
        </div>
      </div>

      <div class="col-xl-12">

        <div class="form-row">
          <div class="col-xl-12">
            <div class="line line-f">
              <label class="label-before">Possui política de responsabilidade socioambiental?</label>
              <label class="custom-checkbox-1 space-labels">Sim
                <input (change)="changeSocioEnvResponsability(true)"
                  [checked]="socioEnvironmental.hasResponsibility === true" type="radio" name="x5" />
                <span class="checkmark radio"></span>
              </label>
              <div class="mr-2"></div>
              <label class="custom-checkbox-1 space-labels">Não
                <input (change)="changeSocioEnvResponsability(false)"
                  [checked]="socioEnvironmental.hasResponsibility === false" type="radio" name="x5" />
                <span class="checkmark radio"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col-xl-12">
            <div class="line line-f">
              <label class="label-before">Possui licença/autorização ambiental?</label>
              <label class="custom-checkbox-1 space-labels">Sim
                <input [checked]="socioEnvironmental.licenceStatusType === 'HaveALicence'"
                  (change)="handleSocioEnvironemntalYesCheck($event)" type="radio" name="x6" />
                <span class="checkmark radio"></span>
              </label>
              <div class="mr-2"></div>
              <label class="custom-checkbox-1 space-labels">Não
                <input [checked]="socioEnvironmental.licenceStatusType === 'NotLicence'"
                  (change)="handleSocioEnvironemntalNoCheck($event)" type="radio" name="x6" />
                <span class="checkmark radio"></span>
              </label>
              <div class="mr-2"></div>
              <label class="custom-checkbox-1">Não se aplica
                <input [checked]="socioEnvironmental.licenceStatusType === 'NotApplicable'" (change)="
                              handleSocioEnvironemntalNotApplicableCheck($event)
                            " type="radio" name="x6" />
                <span class="checkmark radio"></span>
              </label>
            </div>
          </div>
        </div>

      </div>
      <div class="col-xl-12">
        <div class="form-row">
          <div class="col-12">
            <div class="line">
              <div class="label">Observações</div>
              <div class="textarea-overflow">
                <textarea [(ngModel)]="socioEnvironmental.description" class="form-control" rows="3" name=""></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-12">
        <div class="form-title-1">
          Declaração de propósito
          <span
            title="Declaro, em cumprimento ao disposto no artigo 2º, inciso III, da Circular nº 3.461 de 24.07.2009, do Banco Central do Brasil, que o meu relacionamento com a OZ Corretora de Câmbio tem (terá) os seguintes propósitos e natureza: (Pode assinalar mais de uma opção)"
            class="click-info" data-info-id="info-2"><i class="info">i</i></span>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Declaração de residentes
            <input [checked]="purposeStatements.declarationOfResidents"
              (change)="changePurposeOption($event, 'declarationOfResidents')" type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Disponibilidade
            <input [checked]="purposeStatements.availability" (change)="changePurposeOption($event, 'availability')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Exportação
            <input [checked]="purposeStatements.export" (change)="changePurposeOption($event, 'export')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Pagamentos no exterior
            <input [checked]="purposeStatements.paymentsAbroad" (change)="changePurposeOption($event, 'paymentsAbroad')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Turismo
            <input [checked]="purposeStatements.tourism" (change)="changePurposeOption($event, 'tourism')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Recebimentos no exterior
            <input [checked]="purposeStatements.receiptsAbroad" (change)="changePurposeOption($event, 'receiptsAbroad')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Investimentos
            <input [checked]="purposeStatements.investments" (change)="changePurposeOption($event, 'investments')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Importação
            <input [checked]="purposeStatements.import" (change)="changePurposeOption($event, 'import')"
              type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="col-xl-4 col-md-6">
        <div class="line">
          <label class="custom-checkbox-1">Todas as anteriores
            <input (change)="handleMarkAllPurpose($event)" type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

    </div>

    <div class="cadastro-line-btn">
      <div class="form-row">
        <div class="cols">
          <div class="form-group">
            <button type="button" (click)="openCancelModal()" class="btn-xp-m2 btn-blue-30-b">
              Cancelar
            </button>
          </div>
        </div>
        <div class="cols">
          <div class="form-group">
            <button (click)="goPrevious()" type="button" class="btn-xp-m2 btn-blue-30-b">
              Voltar
            </button>
          </div>
        </div>
        <div class="cols">
          <div class="form-group mb-0">
            <button [disabled]="loading" (click)="register()" type="button" class="btn-xp-m2 btn-blue-30">
              Avançar
              <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
